import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { MEALS } from "@/lib/nutri";
import { SearchTab } from "@/components/nutri/SearchTab";
import { PhotoTab } from "@/components/nutri/PhotoTab";
import { CustomTab } from "@/components/nutri/CustomTab";

export const AddFoodDialog = ({ meal, date, onClose, onAdded }) => {
  const label = MEALS.find((m) => m.key === meal)?.label || "";
  const done = () => {
    onAdded();
    onClose();
  };
  return (
    <Dialog open={!!meal} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="add-food-dialog" data-lenis-prevent className="max-h-[90vh] overflow-y-auto border-[rgba(152,191,162,0.25)] bg-[#0b120e] sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl font-900 uppercase">Aggiungi a {label}</DialogTitle>
          <DialogDescription className="text-[#a3b1aa]">Cerca un alimento, fotografa il piatto o crea un alimento personalizzato.</DialogDescription>
        </DialogHeader>
        <Tabs defaultValue="search">
          <TabsList className="grid w-full grid-cols-3 bg-[#050807]">
            <TabsTrigger value="search" data-testid="tab-search">Cerca</TabsTrigger>
            <TabsTrigger value="photo" data-testid="tab-photo">Foto AI</TabsTrigger>
            <TabsTrigger value="custom" data-testid="tab-custom">Personalizzato</TabsTrigger>
          </TabsList>
          <TabsContent value="search"><SearchTab meal={meal} date={date} onDone={done} /></TabsContent>
          <TabsContent value="photo"><PhotoTab meal={meal} date={date} onDone={done} /></TabsContent>
          <TabsContent value="custom"><CustomTab meal={meal} date={date} onDone={done} /></TabsContent>
        </Tabs>
      </DialogContent>
    </Dialog>
  );
};
